import { createAction } from '@ngrx/store';

export const showEulaAction = createAction('[Landing Page] Show EULA form');
